import { useState, useEffect } from 'react';
import { API_URL } from '../Config';

export function useClipStatus(itemId, selectedLanguage) {
  const [clipStatus, setClipStatus] = useState('grey'); // 'red', 'green', 'grey'

  useEffect(() => {
    if (!itemId) return;

    const checkClipConfiguration = async () => {
      try {
        // Check original language configuration
        const originalResponse = await fetch(`${API_URL}/timeline-items/${itemId}/clip-config?language_code=original`);
        let hasOriginalConfig = false;
        if (originalResponse.ok) {
          const originalData = await originalResponse.json();
          // Check if configuration exists and has custom configuration
          hasOriginalConfig = originalData && originalData.has_custom_config === true;
        }

        // Check current language configuration (if not original)
        let hasCurrentLanguageConfig = false;
        if (selectedLanguage !== 'original') {
          const currentLangResponse = await fetch(`${API_URL}/timeline-items/${itemId}/clip-config?language_code=${selectedLanguage}`);
          if (currentLangResponse.ok) {
            const currentLangData = await currentLangResponse.json();
            // Check if configuration exists and has custom configuration
            hasCurrentLanguageConfig = currentLangData && currentLangData.has_custom_config === true;
          }
        }

        // Apply color logic based on user requirements:
        // - Green: clips edited in current language variant
        // - Red: clips edited in original version (when viewing non-original language)
        // - Grey: no edits available in either original or current language variant

        if (selectedLanguage === 'original') {
          // When viewing original language
          setClipStatus(hasOriginalConfig ? 'green' : 'grey');
        } else {
          // When viewing non-original language
          if (hasCurrentLanguageConfig) {
            // Edited in current language variant
            setClipStatus('green');
          } else if (hasOriginalConfig) {
            // Edited in original version
            setClipStatus('red');
          } else {
            // No edits available
            setClipStatus('grey');
          }
        }
      } catch (error) {
        console.error('Error checking clip configuration:', error);
        setClipStatus('grey');
      }
    };

    checkClipConfiguration();
  }, [itemId, selectedLanguage]);

  return clipStatus;
}